module.exports = __webpack_public_path__ + "img/g_store.fa812551.svg";